import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pharmacy = _resolveComponent("Pharmacy")!
  const _component_PatientDme = _resolveComponent("PatientDme")!
  const _component_PatientSupply = _resolveComponent("PatientSupply")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Pharmacy),
    _createVNode(_component_PatientDme, {
      "provider-id": _ctx.patientOptions.data.providerId,
      dmes: _ctx.patientDetails.pharmacyAndDme.dmEs,
      "onUpdate:dmes": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.patientDetails.pharmacyAndDme.dmEs) = $event)),
      "patient-status": _ctx.patientOptions.data.status,
      "patient-vendors": _ctx.patientDetails.pharmacyAndDme.dmeVendors,
      "onUpdate:patient-vendors": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.patientDetails.pharmacyAndDme.dmeVendors) = $event)),
      "order-id": _ctx.patientDetails.pharmacyAndDme.associatedTaskId,
      "is-attach-order-not-required": !!_ctx.patientDetails.pharmacyAndDme.isAttachOrderNotRequired
    }, null, 8 /* PROPS */, ["provider-id", "dmes", "patient-status", "patient-vendors", "order-id", "is-attach-order-not-required"]),
    _createVNode(_component_PatientSupply, {
      "provider-id": _ctx.patientOptions.data.providerId,
      supplies: _ctx.patientDetails.pharmacyAndDme.supplies,
      "onUpdate:supplies": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.patientDetails.pharmacyAndDme.supplies) = $event)),
      "patient-status": _ctx.patientOptions.data.status,
      "patient-vendors": _ctx.patientDetails.pharmacyAndDme.supplyVendors,
      "onUpdate:patient-vendors": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.patientDetails.pharmacyAndDme.supplyVendors) = $event)),
      "order-id": _ctx.patientDetails.pharmacyAndDme.associatedTaskId,
      "is-attach-order-not-required": !!_ctx.patientDetails.pharmacyAndDme.isAttachOrderNotRequired
    }, null, 8 /* PROPS */, ["provider-id", "supplies", "patient-status", "patient-vendors", "order-id", "is-attach-order-not-required"])
  ], 64 /* STABLE_FRAGMENT */))
}